import { Col } from 'react-styled-flexboxgrid';
import styled from 'styled-components';

import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

import { H3 } from '../../atoms/headings';
import { getTextColorBasedOnProps } from '../../theme/helpers';
import { fontStyle } from '../../theme/helpers/fontStyle';

export const $TransportMethod = styled(H3)`
  font-weight: ${fontWeight('medium')};
  ${fontStyle('base')};
`;

export const $Price = styled(H3)`
  ${fontStyle('sm')};
  font-weight: ${fontWeight('normal')};
`;

export const $BrandLogoContainer = styled('div')`
  img {
    width: ${spacing(10)};
  }
`;

export const $DistanceContainer = styled('div')`
  color: ${(props) =>
    getTextColorBasedOnProps({ theme: props.theme, primary: true })};
  display: flex;
  align-items: center;
  margin: ${spacing(1.5)} 0;

  svg {
    color: ${(props) =>
      getTextColorBasedOnProps({ theme: props.theme, primary: true })};
  }
`;

export const $AddressRow = styled.div`
  h3,
  p {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  h3 {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-transform: lowercase;

    &::first-letter {
      text-transform: uppercase;
    }
  }

  p {
    padding-top: ${spacing('md')};
    ${fontStyle('sm')};
    padding-bottom: 0;
  }
  h5 {
    ${fontStyle('sm')}
    font-weight: ${fontWeight('normal')};
  }
`;

export const $AddressCol = styled(Col)`
  display: 'flex';
  flexdirection: 'column';
  justifycontent: 'space-between';
`;
